import { Routes } from '@angular/router';
import { AuthAdminGuard } from '@valhalla/core';
import { developmentRoutes } from './pages-routes.dev';
import { CanActivateDefaultPage } from './default-page.guard';
import { UnsafeChangesGuard } from '../guards/unsave-changes.guard';
import { RedirectNotFoundResolver } from '@spa/pages/not-found/not-found.resolver';

export const productionRoutes: Routes = [
	{
		path: '',
		// redirectTo: 'portal/new',
		pathMatch: 'full',
		canActivate: [CanActivateDefaultPage],
	},
	{
		// сервисные страницы (404...)
		path: 'svc',
		loadChildren: () => import('../pages/svc/svc.module').then(m => m.SvcPagesModule),
	},
	{
		path: 'admin',
		loadChildren: () => import('../pages/admin/admin.module').then(m => m.AdminFeatureModule),
		canActivate: [AuthAdminGuard],
	},
	{
		path: 'tasks',
		loadChildren: () => import('../components/task').then(m => m.FeatureTaskModule),
	},
	{
		path: 'kanban',
		loadChildren: () => import('../pages/kanban/kanban.module').then(m => m.PageKanbanModule),
	},
	{
		path: 'gantt',
		loadChildren: () => import('../pages/gantt/gantt.module').then(m => m.PageGanttModule),
	},
	{
		path: 'portal',
		loadChildren: () => import('../pages/portal/portal.module').then(m => m.DashboardModule),
	},
	{
		path: 'search',
		loadChildren: () => import('../pages/search/search.module').then(m => m.SearchModule),
	},
	{
		path: 'user',
		loadChildren: () => import('../pages/user/user.module').then(m => m.UserModule),
	},
	{
		path: 'jitsi',
		redirectTo: 'conference',
	},
	{
		path: 'conference',
		loadChildren: () => import('../pages/jitsi/jitsi.module').then(m => m.JitsiModule),
	},
	{
		path: 'feeds',
		loadChildren: () => import('../pages/feed/feed.module').then(m => m.FeedModule),
		canDeactivate: [UnsafeChangesGuard],
	},
	{
		path: 'report',
		loadChildren: () => import('../pages/report/report.module').then(m => m.ReportModule),
	},
	{
		path: 'link',
		loadChildren: () => import('../pages/link/link.module').then(m => m.LinkModule),
		canDeactivate: [UnsafeChangesGuard],
	},
	{
		path: 'infra',
		loadChildren: () => import('../pages/infra/infra.module').then(m => m.InfraModule),
	},
	{
		path: 'chat',
		loadChildren: () => import('../pages/chat/chat.module').then(m => m.ChatModule),
		canDeactivate: [UnsafeChangesGuard],
	},
	{
		path: 'demo',
		loadChildren: () => import('../pages/demo/demo.module').then(m => m.DemoPagesModule),
	},
	{
		path: 'data-source',
		loadChildren: () => import('../pages/data-source/data-source.module').then(m => m.DataSourcePageModule),
	},
	{
		path: 'scheduler',
		loadChildren: () => import('../pages/scheduler/scheduler.module').then(m => m.SchedulerPageModule),
	},
	{
		path: 'subcat',
		loadChildren: () => import('../pages/subcat/subcat.module').then(m => m.SubcatModule),
	},
	{
		path: 'org',
		loadChildren: () => import('../pages/org/org.module').then(m => m.OrgPageModule),
	},
	{
		path: 'survey',
		loadChildren: () => import('../pages/survey/survey.module').then(m => m.SurveyModule),
	},
	{
		path: 'administration',
		loadChildren: () =>
			import('../pages/administration/administration-page.module').then(m => m.AdministrationPageModule),
	},
	{
		path: 'calendar',
		loadChildren: () => import('../pages/calendar/calendar-page.module').then(m => m.CalendarPageModule),
	},
	{
		path: 'scheduling-assistant',
		loadChildren: () =>
			import('../pages/scheduling-assistant/scheduling-assistant-page.module').then(
				m => m.SchedulingAssistantPageModule
			),
	},
	{
		path: 'resolutions',
		loadChildren: () => import('../pages/resolutions/resolutions.module').then(m => m.PageResolutionsModule),
	},
	{
		path: 'task-hierarchy',
		loadChildren: () => import('../pages/task-hierarchy/task-hierarchy.module').then(m => m.TaskHierarchyModule),
	},
	{
		path: 'subtasks',
		loadChildren: () => import('../pages/subtasks/subtasks-page.module').then(m => m.SubtasksPageModule),
	},
	{
		path: 'timeline-events',
		loadChildren: () => import('../pages/timeline-events/timeline-events.module').then(m => m.TimelineEventsPageModule),
	},
	{
		path: 'resource-table',
		loadChildren: () =>
			import('../common/components/resource-table/resource-table.module').then(m => m.ResourceTableModule),
	},
	{
		path: 'resource-table',
		loadChildren: () =>
			import('../common/components/resource-table/resource-table.module').then(m => m.ResourceTableModule),
	},
	{
		path: 'error/404',
		resolve: {
			fromUrl: RedirectNotFoundResolver,
		},
		loadChildren: () => import('../pages/not-found/not-found.module').then(m => m.NotFoundModule),
	},
	{
		path: 'error/500',
		loadChildren: () => import('../pages/error/error.module').then(m => m.ErrorModule),
	},
	{
		path: 'error/403',
		loadChildren: () => import('../pages/forbidden/forbidden.module').then(m => m.ForbiddenModule),
	},
	{
		path: 'icons',
		loadChildren: () => import('../pages/icons/icons.module').then(m => m.IconsModule),
	},
	{
		path: 'newtask',
		loadChildren: () => import('../components/new-task/feature-new-task.module').then(m => m.FeatureNewTaskModule),
	},
];

export const pagesRoutes: Routes = [...productionRoutes, ...developmentRoutes];
